import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Home from './components/Home';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import Footer from './components/Footer';
import Dashboard from './components/Dashboard';
import Download from './components/Download';
import Product from './components/Product';
import Contact from './components/Contact';
import Settings from './components/Settings';
import AutoLogout from './components/AutoLogout';
import AddToCart from './components/AddToCart';
import CheckoutPage from './components/CheckoutPage'; 
import { Toaster } from 'react-hot-toast';

import { AuthProvider } from './components/AuthContext'; 
import { CartProvider } from './components/CartContext'; 
import { ApiProvider } from './components/ApiContext'; 

import PaymentStatus from './components/PaymentStatus';
import Gallery from './components/dashboard/Gallery';
import Apks from './components/dashboard/ApkManager';
import MaintenancePage from './components/MaintenancePage'; // ⬅️ DIBETULKAN PATH

const AppContent = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // Logic untuk menentukan page apa yang sedang dibuka
    const isAuthPage = location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/forgot-password';
    const isMaintenance = location.pathname === '/maintenance';

    return (
        <div>
            {/* ➡️ Header & AutoLogout disorok jika berada di page Auth atau Maintenance */}
            {!isAuthPage && !isMaintenance && <Header />}
            {!isAuthPage && location.pathname !== '/' && !isMaintenance && <AutoLogout />}
            
            <Toaster />

            <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/signup" component={Signup} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/download" component={Download} />
                <Route path="/product" component={Product} />
                <Route path="/contact" component={Contact} />
                <Route path="/settings" component={Settings} />
                <Route path="/addtocart" component={AddToCart} />
                <Route path="/checkout" component={CheckoutPage} />
                <Route path="/payment-status" component={PaymentStatus} />
                <Route path="/gallery" component={Gallery} />
                <Route path="/apks" component={Apks} />
                <Route path="/maintenance" component={MaintenancePage} />
            </Switch>

            {!isAuthPage && !isMaintenance && <Footer />}
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <ApiProvider> 
                <AuthProvider>
                    <CartProvider>
                        <AppContent />
                    </CartProvider>
                </AuthProvider>
            </ApiProvider>
        </Router>
    );
};

export default App;